﻿'use strict';

/**
* Directive for the footer
* @memberOf components.footerModule
* @namespace ebFooter
*/
ebFooter.$inject = ['$window'];

function ebFooter($window) {
    // Usage: <ebFooter></ebFooter>

    var directive = {
        restrict: 'E',
        scope: false,
        templateUrl: require('./ebFooter.html'),
        controller: 'footerController'
    };
    return directive;
}

module.exports = ebFooter;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/footer/ebFooterDirective.js
// module id = 52
// module chunks = 0